export const config = () => {
  let BASE_URL;
  let APPID = "844239";
  let AppSECRET = "kU9IPc0C65";
  let SOCKET_URL;
  let MYACCOUNTSERVICE_URL
  let STT_NLP 
  let CAMPAIGN_URL ;
  let LOGIN_API;
  let MYACCOUNT_URL;
  const env = import.meta.env.VITE_APP_ENV;
  if (env === 'production') {
    BASE_URL = "https://cvm-api.worktual.co.uk/cvm_api_service/v1";
    SOCKET_URL = "https://cvm-api.worktual.co.uk";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    STT_NLP = "https://aichat.worktual.co.uk/audra_voice";
    CAMPAIGN_URL ="https://campaign.worktual.co.uk";
    LOGIN_API= "https://urapi.worktual.co.uk/urauth/v1/token/create_jwt"
    MYACCOUNT_URL = "https://myaccount.worktual.co.uk";
    // CAMPAIGN_URL ="http://localhost:4000";
  } else if (env === 'qa') {
    BASE_URL = "https://qa-cvm-api.worktual.co.uk/cvm_api_service/v1";
    SOCKET_URL = "https://qa-cvm-api.worktual.co.uk";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    LOGIN_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    MYACCOUNT_URL = "https://qa-myaccount.worktual.co.uk";
    STT_NLP = "https://aichat.worktual.co.uk/audra_voice";
  } else {
    BASE_URL = "http://localhost:2000/cvm_api_service/v1";
    SOCKET_URL = "http://localhost:2001";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    LOGIN_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    MYACCOUNT_URL = "https://qa-myaccount.worktual.co.uk";
  }

  return {
    BASE_URL,
    APPID,
    AppSECRET,
    SOCKET_URL,
    MYACCOUNTSERVICE_URL,
    STT_NLP,
    CAMPAIGN_URL,
    LOGIN_API,
    MYACCOUNT_URL
  };
};


export const DASHBOARD = [
  '/dashboard'
]
export const CONTACTS = [
  '/contacts'
]
export const CUSTOMER_VALUE = [
  '/customer_value_segment'
]
export const CAMPAIGN_REPORTS = [
  '/campaign_reports'
]
export const CAMPAIGN = [
  '/campaign',
  '/email-campaign',
  '/sms-campaign',
  '/whatsapp-campaign'
]
export const SETTINGS = [
  '/settings'
]
export const ANALYTICS = [
  '/analytics',
  '/ai_analytics',
  '/revenue_analytics',
  '/campaign_analytics',
  '/nps_analytics',
]